const API_URL = 'https://api.kandy.debaly.com';

export {API_URL}
